import { Overlay } from '@euler/app/flows/report/components/VehicleFacadeBirdView.shared';
import { FacadePerspectiveRenderer } from '@euler/app/flows/report/functions/FacadePerspectiveRenderer';
import { onErrorIgnore } from '@euler/utils';
import { memo, useEffect, useMemo, useRef } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

let CanvasIDSeed = 0;

export const VehicleFacadeBirdView = memo(
  ({
    size,
    overlays,
    style,
    bgColor = '#ffffff',
  }: {
    size: number;
    overlays: Overlay[];
    bgColor?: string | null;
    style?: StyleProp<ViewStyle>;
  }) => {
    const id = useMemo(() => ++CanvasIDSeed, []);
    const canvasId = `facade-image-canvas-${id}`;
    const offscreenCanvasId = `facade-image-offscreen-canvas-${id}`;
    const renderer = useRef<FacadePerspectiveRenderer>();
    useEffect(() => {
      (async () => {
        if (!renderer.current) {
          renderer.current = new FacadePerspectiveRenderer(
            `#${canvasId}`,
            `#${offscreenCanvasId}`,
          );
          await renderer.current.initialize();
          if (bgColor != null) {
            renderer.current.setStyle({ bgColor });
          }
        }
        await renderer.current.render(overlays);
      })().catch(onErrorIgnore);
    }, [bgColor, canvasId, offscreenCanvasId, overlays]);
    return (
      <View style={style}>
        <canvas id={canvasId} style={{ width: size, height: size }} />
        <canvas
          id={offscreenCanvasId}
          style={{
            width: size,
            height: size,
            position: 'absolute',
            left: '-9999rem',
            top: '-9999rem',
          }}
        />
      </View>
    );
  },
);
